import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';

const defaultFilter = [
  { label: '目', value: '目' },
  { label: '鼻', value: '鼻' },
  { label: '口', value: '口' },
  { label: '耳', value: '耳' },
];

type KartesListType = {
  schemaList: any;
  handleRowClick: (rowIndex: number) => void;
};

const KartesList: React.FC<KartesListType> = ({
  schemaList,
  handleRowClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState(defaultFilter);

  const openPopover = Boolean(anchorEl);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const rowClick = (row: any) => {
    handleRowClick(row);
  };

  const handleFilterChange = (event: any, value: any) => {
    // const status = value.map((val: any) => val.value);
    setFilters(defaultFilter);
  };

  return (
    <Box position={'absolute'} top={50} left={0} width={'100%'} zIndex={1001}>
      <Autocomplete
        multiple
        id='tags-outlined'
        options={filters}
        getOptionLabel={(option: any) => option.label}
        // defaultValue={[statuses[2]]}
        isOptionEqualToValue={(stat: any, value) => stat.value === value.value}
        filterSelectedOptions
        onChange={handleFilterChange}
        renderInput={(params) => (
          <TextField {...params} label='' placeholder='カルテ' />
        )}
        sx={{
          flex: 1,
          backgroundColor: 'primary.light',
          '&.MuiAutocomplete-root .MuiOutlinedInput-root': {
            py: '7px',
          },
          '&.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input':
            {
              py: 0,
              fontSize: '12px',
            },
        }}
      />
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none',
        }}
      >
        <Table
          sx={{
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '6px',
            },
          }}
          aria-label='simple table'
        >
          <TableBody>
            {schemaList.map((row: any, index: number) => {
              return (
                <TableRow
                  hover
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '& .MuiTableCell-root.MuiTableCell-body': {
                      py: '4px',
                      borderBottom: '1px solid #F3F3F3',
                    },
                    cursor: 'pointer',
                  }}
                  onClick={() => rowClick(index)}
                >
                  <TableCell width={'90px'} sx={{ minWidth: '90px' }}>
                    <Box
                      component='img'
                      src={row.records[0]?.items[0]?.thumbnail || ''}
                      alt='face-patient'
                      width={'40px'}
                      height={'auto'}
                      sx={{ cursor: 'pointer' }}
                      border={'1px solid #F3F3F3'}
                      onMouseEnter={(event) => handlePopoverOpen(event)}
                      onMouseLeave={handlePopoverClose}
                    />
                    <Popover
                      id='mouse-over-popover'
                      open={openPopover}
                      anchorEl={anchorEl}
                      onClose={handlePopoverClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      sx={{
                        pointerEvents: 'none',
                        '& .MuiPaper-root.MuiPopover-paper': {
                          boxShadow: 'none',
                          height: '150px',
                          overflowY: 'hidden',
                        },
                      }}
                    >
                      <Box
                        component='img'
                        src={row.records[0]?.items[0]?.thumbnail || ''}
                        alt='face-patient'
                        width={'200px'}
                        height={'150px'}
                        sx={{ objectFit: 'contain' }}
                        border={'4px solid #F3F3F3'}
                      ></Box>
                    </Popover>
                  </TableCell>
                  <TableCell align='left'>{row.kartedate}</TableCell>
                  <TableCell align='left'>{row.doctors}</TableCell>
                  <TableCell align='left'>{row.kartetext}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default KartesList;
